import { ApiService } from "../../../config";
import { TPaymentQRCodeResponse } from "../models";
import { handleError } from "@/utils/parseApiReturn";

interface IRequestProps {
  price: number;
  amount: number;
  selectedAccount: number;
}
interface IReturnShowPlan {
  data?: { minCredits?: number; price?: string };
  success: boolean;
  message: string;
}

interface IShowPlanProps {
  planId: number;
}

const createPayment = async ({
  price,
  amount,
  selectedAccount
}: IRequestProps): Promise<{
  success?: boolean;
  message: string;
  data?: TPaymentQRCodeResponse;
}> => {
  try {
    const { data: resData } = await ApiService.post("payment/generate", {
      creditsPrice: price,
      accountId: selectedAccount,
      creditsAmount: amount
    });
    return resData;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para gerar pagamento:");
  }
};

const showPlan = async ({
  planId
}: IShowPlanProps): Promise<IReturnShowPlan> => {
  try {
    const result = await ApiService.get(`plans/${planId}`);
    return result.data;
  } catch (error) {
    return handleError(error, "Erro inesperado ao obter plano:");
  }
};
const generateNFE = async (
  paymentId: string,
  paymentValue: number,
  accountId: number
) => {
  try {
    const { data } = await ApiService.post("payment/generate-nfe", {
      paymentId,
      paymentValue,
      accountId
    });
    return { success: true, message: data.message };
  } catch (error: any) {
    console.error("error", error);
    const { message } = error.response.data;
    return { success: false, message };
  }
};

export const CreditService = { createPayment, showPlan, generateNFE };
